/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { ConfigFieldReset } from "./ConfigFieldReset";
import {
  ConfigFieldResetFromJSON,
  ConfigFieldResetFromJSONTyped,
  ConfigFieldResetToJSON,
  ConfigFieldResetToJSONTyped,
} from "./ConfigFieldReset";

/**
 *
 * @export
 * @interface ConfigRepairPreview
 */
export interface ConfigRepairPreview {
  /**
   *
   * @type {Array<ConfigFieldReset>}
   * @memberof ConfigRepairPreview
   */
  resets: Array<ConfigFieldReset>;
  /**
   *
   * @type {boolean}
   * @memberof ConfigRepairPreview
   */
  resetsEverything: boolean;
  /**
   *
   * @type {string}
   * @memberof ConfigRepairPreview
   */
  unrepairableReason?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof ConfigRepairPreview
   */
  unlinksStore: boolean;
}

/**
 * Check if a given object implements the ConfigRepairPreview interface.
 */
export function instanceOfConfigRepairPreview(
  value: object,
): value is ConfigRepairPreview {
  if (!("resets" in value) || value["resets"] === undefined) return false;
  if (!("resetsEverything" in value) || value["resetsEverything"] === undefined)
    return false;
  if (!("unlinksStore" in value) || value["unlinksStore"] === undefined)
    return false;
  return true;
}

export function ConfigRepairPreviewFromJSON(json: any): ConfigRepairPreview {
  return ConfigRepairPreviewFromJSONTyped(json, false);
}

export function ConfigRepairPreviewFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ConfigRepairPreview {
  if (json == null) {
    return json;
  }
  return {
    resets: (json["resets"] as Array<any>).map(ConfigFieldResetFromJSON),
    resetsEverything: json["resetsEverything"],
    unrepairableReason:
      json["unrepairableReason"] == null
        ? undefined
        : json["unrepairableReason"],
    unlinksStore: json["unlinksStore"],
  };
}

export function ConfigRepairPreviewToJSON(json: any): ConfigRepairPreview {
  return ConfigRepairPreviewToJSONTyped(json, false);
}

export function ConfigRepairPreviewToJSONTyped(
  value?: ConfigRepairPreview | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    resets: (value["resets"] as Array<any>).map(ConfigFieldResetToJSON),
    resetsEverything: value["resetsEverything"],
    unrepairableReason: value["unrepairableReason"],
    unlinksStore: value["unlinksStore"],
  };
}
